import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';
import Picture from "@/js/react/src/components/ui/Picture";
import Calendar from "@/js/react/src/components/ui/icons/classic/regular/Calendar";

export default function Hit({ hit, results, additionalData }: componentTypes.HitProps) {
  const {
    id,
    title,
    image,
    newsCategories,
    newsTags,
    shortDescription,
    excerpt,
    postDateFormatted,
  } = hit;

  const {
    hitClasses,
  } = additionalData;

  const hitIndex = results.hits.findIndex((h) => h.id === id);
  const lazyLoadImage = hitIndex > 4;
  let tag = newsTags && newsTags.length > 0 ? newsTags[0].title ?? '': '';
  if (tag === '') {
    tag = newsCategories && newsCategories.length > 0 ? newsCategories[0].title ?? '': '';
  }
  const text = shortDescription ?? excerpt ?? '';
  return (
    <div className={`${hitClasses ?? 'w-full'} rounded-2xl flex aspect-3/4`}>
      <a
        href={Craft.getSiteUrl(hit.uri, '')}
        className="group/card size-full relative flex flex-col justify-start no-underline transition-all overflow-hidden rounded-2xl border border-dark/10 gap-6 bg-light hover:shadow-card-hover transition-all"
      >
        {image && (<Picture
          pictureClasses="block aspect-16/9 w-full z-1 overflow-hidden shrink-0"
          image={image}
          classes="size-full"
          defaultTransform="all"
          loading={lazyLoadImage ? 'lazy' : 'eager'}
        />)}
        <div className="z-1 flex flex-col gap-4 p-6 pt-0 md:p-8 md:pt-0 bg-light">
          <h3 className="text-dark text-md/6 md:text-lg/7 font-semibold group-hover/card:text-blue-300 transition-all order-2">{title}</h3>
          <div className="flex justify-start text-gray-500 items-center gap-2 order-1">
            <Calendar iconClass="w-4.5 -mt-0.5" />
            <span className="text-2xs/4 md:text-xs/5">{postDateFormatted}</span>
          </div>
          {tag && (
            <div className="w-fit absolute top-0 left-6 md:left-8 z-4 px-4 py-1.5 bg-light/80 rounded-bl-md rounded-br-md border-l border-r border-b border-dark/10 inline-flex justify-start items-center">
              <div className="text-grey-500 text-2xs/4 md:text-xs/5 font-normal uppercase tracking-wider">
                {tag}
              </div>
            </div>
          )}
          {text &&
            (<div className="text-grey-500 text-xs/5 md:text-sm/6 font-normal line-clamp-3 overflow-hidden order-3">{text}</div>)
          }
        </div>
      </a>
    </div>
  );
}
